var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-box"},[(_vm.title)?_c('div',{staticClass:"search-title"},[_vm._v(_vm._s(_vm.title))]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"search-body"},[(_vm.searchTitle)?_c('div',{staticClass:"search-card-title"},[_vm._v(_vm._s(_vm.searchTitle))]):_vm._e(),_vm._v(" "),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }